import React, { useMemo, useRef } from "react";
// import Plot from "react-plotly.js";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../../../components/Loader/loader";
import PlotComponent from "../visualization/plot/plot";

const MultiChartPopup = ({
  open,
  onClose,
  control_chart = {},
  pcc_chart = {},
  isLoading,
}) => {
  const plotRef = useRef(null);

  // Helper: transform your backend chart object into Plotly chart props
  const getChartsArray = useMemo(() => {
    const chartList = [];

    const processChartObject = (chartObj, type) => {
      Object.keys(chartObj).forEach((key) => {
        const chart = chartObj[key];

        // If status != 200, show message
        if (chart.status && chart.status !== 200) {
          chartList.push({
            id: `${type}-${key}`,
            error: chart.message || "Unable to render chart",
          });
        } else {
          try {
            const parsed = JSON.parse(chart.plot_data || "{}");
            chartList.push({
              id: `${type}-${key}`,
              data: parsed.data || [],
              layout: parsed.layout || {},
              config: parsed.config || {},
              titles: chart.titles || key,
              // axisTitle: chart?.titles,
            });
          } catch (e) {
            chartList.push({
              id: `${type}-${key}`,
              error: "Invalid chart data",
            });
          }
        }
      });
    };

    processChartObject(control_chart, "control");
    processChartObject(pcc_chart, "pcc");

    return chartList;
  }, [control_chart, pcc_chart]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#1B4F8C",
          color: "#fff",
          fontWeight: 600,
          p: 1,
          pl: 2,
        }}
      >
        Charts
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      {isLoading?.kpigraph?.loading ? (
        <Box
          sx={{
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </Box>
      ) : (
        <DialogContent
          dividers
          sx={{
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "#f9fafb",
          }}
        >
          <Grid container spacing={3}>
            {getChartsArray.map((chart) => (
              <Grid item xs={12} key={chart.id}>
                <Box
                  sx={{
                    height: 450,
                    background: "#fff",
                    borderRadius: 2,
                    p: 1,
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {chart.error ? (
                    <Typography color="error">{chart.error}</Typography>
                  ) : (
                    // <Plot
                    //   data={chart.data}
                    //   layout={{
                    //     ...chart.layout,
                    //     autosize: true,
                    //     uirevision: "static",

                    //     title: { text: chart.title || "", x: 0.5 },

                    //     // ✅ FORCE AXES
                    //     xaxis: {
                    //       title: {
                    //         text: chart?.axisTitle?.x_axis_title || "",
                    //       },
                    //       showgrid: true,
                    //       showline: true,
                    //       zeroline: false,
                    //       showticklabels: true,
                    //     },

                    //     yaxis: {
                    //       title: {
                    //         text: chart?.axisTitle?.y_axis_title || "",
                    //       },
                    //       showgrid: true,
                    //       showline: true,
                    //       zeroline: false,
                    //       showticklabels: true,
                    //     },

                    //     margin: { t: 60, b: 50, l: 60, r: 30 },
                    //   }}
                    //   config={{
                    //     responsive: true,
                    //     scrollZoom: true,
                    //     displaylogo: false,
                    //     ...chart.config,
                    //   }}
                    //   style={{ width: "100%", height: "100%" }}
                    //   useResizeHandler
                    // />
                    <PlotComponent
                      plotKey={chart.id || `plot-${Date.now()}`}
                      data={chart.data}
                      layout={chart.layout}
                      config={chart.config}
                      plotRef={plotRef}
                      plotTitles={chart?.titles}
                      fullHeightProps={true}
                    />
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default MultiChartPopup;
